var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"data-udata-reuse":_vm.reuse}}),_c("script",{tag:"component",attrs:{"data-udata":"https://www.data.gouv.fr/","src":"https://static.data.gouv.fr/static/oembed.js","async":"","defer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }